import { createContext } from 'react';

export const ContentTableContext = createContext(null);
export const ContentTableContextProvider = ContentTableContext.Provider;
